import { Box, List, ListItemButton, ListItemText } from "@mui/material";
import { NavLink } from "react-router-dom";

const menuItems = [
  { label: "Menú", path: "." },
  { label: "Tipos", path: "tipos" },
  { label: "Niveles", path: "niveles" },
  { label: "Asignaturas", path: "asignaturas" },
  { label: "Objetivos", path: "objetivos" },
];

const OASSidebar = () => {
  return (
    <Box
      sx={{
        width: 150,
        maxWidth: 150,
        bgcolor: "transparent",
        display: "flex",
        flexDirection: "column",
        borderRight: "2px solid #336B87",
        p: 1,
        minHeight: "100%",
      }}
    >
      <List sx={{ p: 0 }}>
        {menuItems.map((item) => (
          <ListItemButton
            component={NavLink}
            to={item.path}
            relative="path"
            end={item.path === "."}
            key={item.path || "root"}
            sx={{
              color: "#336B87",
              textDecoration: "none",
              "&:hover": { bgcolor: "rgba(51,107,135,0.06)" },

              "&.active": {
                bgcolor: "rgba(51,107,135,0.06)",
                "& .MuiListItemText-primary": {
                  fontWeight: 600,
                },
              },
            }}
          >
            <ListItemText
              primary={item.label}
              primaryTypographyProps={{
                fontFamily: "Montserrat",
                fontWeight: 400, // default
              }}
            />
          </ListItemButton>
        ))}
      </List>
    </Box>
  );
};

export default OASSidebar;
